import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import useCursorHighlight from './hooks/useCursorHighlight';

function App(): React.ReactElement {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('theme') || 'dark';
  });

  useCursorHighlight();

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  return (
    <div className='main'>
      <Navbar theme={theme} toggleTheme={toggleTheme} />
      <Home />
    </div>
  );
}

export default App;
